import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import { CensusStepSectionStyled } from '../CensusStepSectionStyled';

export const CensusStepSectionWithLoaderStyled = styled(CensusStepSectionStyled)`
  position: relative;
`;

export const FileUploadWrapperStyled = styled.div`
  width: 80%;
`;

export const ValidationErrorMessageStyled = styled.div`
  color: ${colors.red[600]};
  font-size: 1.6rem;
  margin: 1rem 0 0;
`;

export const CheckSectionWrapperStyled = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const ErrorMessageStyled = styled.p`
  color: ${colors.red[600]};
  font-size: 1.4rem;
  position: absolute;
  margin: 0;
  top: -3rem;
`;
